/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * A schema that defines a linked reference to Resource.
 */
export interface LinkedRef {
    /** Just regular URI according to [RFC 3986](https://www.rfc-editor.org/rfc/rfc3986). */
    blobId: string;
    /**
     * The [Multibase](https://www.w3.org/TR/cid/#multibase)-encoded sha2-256 [Multihash](https://www.w3.org/TR/cid/#multihash) value.
     *
     * See [Resource Integrity](https://www.w3.org/TR/vc-data-integrity/#resource-integrity).
     */
    digestMultibase: string;
    /**
     * The primary and unique identifier of the resource (inside tenant)
     * according to [RFC 4122](https://www.rfc-editor.org/info/rfc4122).
     */
    resourceId: string;
}
